<template>
  <Card class="stats-card">

    <canvas id="myChart" width="400" height="125"></canvas>
    <!--<p style="margin-bottom:24px; margin-top:24px;">*Concurrent viewers graph represent all connections including different devices of same user.</p>-->
  </Card>
</template>

<script>
import Chart from 'chart.js';
import {mapState, mapGetters, mapActions} from 'vuex'
import moment from 'moment'

export default {
  props: ['sessionId'],
  data() {
    return {
      labels: [],
      chartData: [],
      isLoading: false,
      chart: null,
    }
  },
  computed:{
    ...mapGetters('webcast', {
      webcast: 'getCopy'
    }),
    ...mapGetters('webcast-session', {
      session: 'getCopy'
    }),
    ...mapGetters('realtime-stats', {
      statsInStore: 'find'
    }),
    ...mapGetters('page-settings', {
      pageSettings: 'getCopy',
    })
  },
  watch: {
    stats(){
      if(this.$data.chart){
        console.log(this.$data.chartData);
        this.getChartData().then(()=>{
          this.$data.chart.data.datasets[0].data.pop();
          this.$data.chart.data.datasets[0].data = this.$data.chartData;

          if(this.$data.chart.labels){
              this.$data.chart.data.labels.pop();
          }

          this.$data.chart.data.labels = this.$data.labels;

          this.$data.chart.update();
        })
      }
    },
  },
  watch:{
    sessionId(s){
      this.$store.commit('realtime-stats/clearAll');
      var stats =  this.findStatsAction({
          query: {
            'webcastId': this.webcast._id,
            'sessionId': this.sessionId
          }
      }).then(()=>{
        this.getChartData().then(()=>{
          this.createChart();
        });
      });
    }
  },
  methods: {
    ...mapActions('realtime-stats', {
      findStatsAction: 'find'
    }),
    ...mapActions('webcast-session', {
      getSessionAction: 'get'
    }),
    /*
    ...mapActions('session-connections', {
      findConnectionsAction: 'find'
    }),
    */
    async getChartData(){
      var data = [];
      var labels = [];
      let counts = {};

      let stats = this.statsInStore({query:{
        webcastId: this.webcast._id,
        sessionId: this.sessionId
      }});


      _.forEach(stats.data, (streamStat, key)=>{
        if(this.pageSettings.registrationEnabled){
          _.forEach(streamStat.attConnections, (count, time)=>{
            if(_.has(counts,time)){
              counts[time] += count;
            } else {
              counts[time] = count;
            }
          })
        } else {
          _.forEach(streamStat.deviceConnections, (count, time)=>{
            if(_.has(counts,time)){
              counts[time] += count;
            } else {
              counts[time] = count;
            }
          })
        }
      })

      if(_.size(counts)>=1){
        _.forEach(counts, (value, key)=>{
          labels.push(moment.unix(key/1000));
          data.push(value);
        });

        this.$set(this.$data, 'chartData', data);
        this.$set(this.$data, 'labels', labels);
        //this.yStep = stats.data[0].attConnections
      }

      return data;
    },

    createChart(){
      var ctx = document.getElementById("myChart").getContext('2d');
    //console.log(this.rtStats.connConnections);

      this.$data.chart = new Chart(ctx, {
          type: 'line',
          data: {
              labels: this.$data.labels,
              datasets: [{
                  fill: false,
                  label: '# Concurrent Viewers',
                  data: this.$data.chartData,
                  borderWidth: 2,
                  backgroundColor: 'rgb(54, 162, 235)',
                  borderColor: 'rgb(54, 162, 235)',
                  pointRadius: 0
              }]
          },
          options: {
              scales: {
                  yAxes: [{
                    ticks: {

                      beginAtZero:true,
                      
                    }
                  }],
                  xAxes: [{
                      type: 'time',
                      time: {
                          unit: 'minute',
                          displayFormats: {
                            minute: 'hh:mm'
                          },
                          stepSize: 5,
                          distribution: 'linear'
                      },
                      ticks: {
                          source: 'auto',
                          beginAtZero:true
                      }
                  }]
              }
          }
      });
    }
  },
  created(){
    var stats =  this.findStatsAction({
      query: {
        'webcastId': this.webcast._id,
        'sessionId': this.sessionId
      }
    }).then(()=>{
      this.getChartData().then(()=>{
        this.createChart();
      });
    });
  }
}
</script>

<style>

</style>
